export default __webpack_public_path__ + "static/media/icone_audio_rid.8a518813.svg";